module.exports = __webpack_public_path__ + "img/GazEuropeen.a85514e1.png";